import { List, SignOut, User } from 'phosphor-react';
import React, { useState } from 'react';
import Breadcrumb from '../Breadcrumb';

import {
  AvatarImage, DropdownUsername, MainHeader, UserContainer, UserName, MenuIcon
} from './styles';
import UserPerfil from '../UserPerfil';
import { useUser } from '../../hooks/user';
import { pickTextColorBasedOnBgColorSimple } from '../../utils/getFontDarkOrLight';
import { Dropdown, DropdownItemProps, Image } from 'semantic-ui-react';

interface Props {
  screen: string;
  logout: () => Promise<void>;
  onOpenMenu?: () => void;
}

const Header: React.FC<Props> = ({ screen, logout, onOpenMenu }) => {
  // ... existing code ...

  // ... (imports needing update to include List from phosphor-react if not present, but it seems I can just use Semantic Icon or import List)
  // Actually let's check imports. File content showed SignOut, User imported. I will add List to imports in next step if needed, or assume it's available. 
  // Let's modify the return.

  const [dropDownOpen, setDropDownOpen] = useState(false)

  const {
    userInfo
  } = useUser()

  function closeModal() {
    setDropDownOpen(false)
  }

  const dropdownOptions: DropdownItemProps[] = [
    { key: 'user', text: 'Minha Conta', icon: <User weight="thin" size={19} style={{ marginRight: '0.5rem', color: '#56B8F8' }} /> },
    { key: 'sign-out', text: 'Sair', icon: <SignOut weight="thin" size={19} style={{ marginRight: '0.5rem', color: '#56B8F8' }} />, onClick: logout }
  ].filter(Boolean)

  const avatarSrc = userInfo?.foto || `https://ui-avatars.com/api/?background=${userInfo?.color?.replace('#', '') || 'ccc'}&color=${pickTextColorBasedOnBgColorSimple(userInfo?.color || '#ccc').replace('#', '')}&name=${userInfo?.nome || 'User'}`;
  const userName = userInfo?.nome || 'Usuário';

  const dropdownTrigger = (
    <DropdownUsername>
      <Image avatar src={avatarSrc} /> {userName}
    </DropdownUsername>
  )

  return (
    <MainHeader>

      <div style={{ display: 'flex', alignItems: 'center', gap: '15px', marginLeft: 'auto' }}>
        <DropdownUsername>
          <Image avatar src={avatarSrc} /> {userName}
        </DropdownUsername>

        {onOpenMenu && (
          <MenuIcon
            size={32}
            weight="bold"
            onClick={onOpenMenu}
          />
        )}
      </div>
    </MainHeader>
  );
}
export default Header;